exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".empty-state[data-v-189732a8]{border:4px dashed #ddd;border-radius:1rem;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;height:100%;margin:1rem;color:#d1d1d1}.empty-state .heading[data-v-189732a8]{font-size:24px;font-weight:600;color:#96b1ff;margin-top:10px}.empty-state .sub-heading[data-v-189732a8]{margin-top:10px;margin-bottom:40px;font-size:16px;font-weight:500;color:#bcbcbc}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-189732a8","scoped":true,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/EmptyState.vue
// module id = 9Pkm
// module chunks = 113